import React from "react";
import { SVGType } from "./menu/PolicyMenu";
import { ReactComponent as IconLinkedIn } from "../../assets/img/icon/social-network/linkedin.svg";
import { ReactComponent as IconFacebook } from "../../assets/img/icon/social-network/facebook.svg";
import { ReactComponent as IconInstagram } from "../../assets/img/icon/social-network/instagram.svg";
import { ReactComponent as IconTiktok } from "../../assets/img/icon/social-network/tiktok.svg";
import { ProdesegButton, ProdesegButtonEnumTypes } from "../../components/ProdesegButton/ProdesegButton";
import { useWindowBreakpoints } from "../../custom-hooks/useWindowBreakpoints";
import { ProdesegAnnouncement } from "./components/ProdesegAnnouncement/ProdesegAnnouncement";

interface SocialNetworkLink {
    name: string;
    icon: SVGType;
    href: string;
}

const socialNetworkLinks: SocialNetworkLink[] = [
    { name: "facebook", icon: IconFacebook, href: "https://www.facebook.com/Prodeseg.Seguros" },
    { name: "instagram", icon: IconInstagram, href: "https://www.instagram.com/prodeseg.seguros/" },
    { name: "tiktok", icon: IconTiktok, href: "https://www.tiktok.com/@prodeseg" },
    { name: "linkedin", icon: IconLinkedIn, href: "https://www.linkedin.com/company/prodeseg-seguros" },
];

export const SocialNetworkLinks: React.FC<{ full?: boolean }> = ({ full = false }) => {
    const { isDownMd } = useWindowBreakpoints();

    return (
        <div
            className={`social-network__links ${full ? "full" : ""} d-flex flex-wrap ${isDownMd ? "px-4 justify-content-between align-content-center" : "content-center"}`}
        >
            {isDownMd && <ProdesegAnnouncement />}
            <div className="d-flex">
                {socialNetworkLinks.map(networkLink => (
                    <ProdesegButton
                        key={networkLink.name}
                        type={ProdesegButtonEnumTypes.Dark}
                        Icon={networkLink.icon}
                        onlyIcon
                        onClick={() => window.open(networkLink.href)}
                        isOutline
                        className={"border-0"}
                    />
                ))}
            </div>
        </div>
    );
};
